import React from 'react';

function MissingSelectOption({ value, options, getOptionValue, label = 'not in list' }) {
  if (value == null || value === '') {
    return null;
  }

  const normalizedValue = String(value).trim();
  if (options.some((option) => String(getOptionValue(option)).trim() === normalizedValue)) {
    return null;
  }

  return (
    <option value={normalizedValue}>
      {normalizedValue} ({label})
    </option>
  );
}

export default MissingSelectOption;
